import * as React from "react"
import { useEffect, useRef, useState, useCallback } from "react"

import { cn } from "@/lib/utils"
import { useGamepadNavigation } from "@/hooks/use-gamepad-navigation"
import { useSpeechRecognition } from "@/hooks/useSpeechRecognition"


export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, value, onChange, ...props }, ref) => {
    const textareaRef = useRef<HTMLTextAreaElement | null>(null)
    const [internalValue, setInternalValue] = useState('');
    const [isRecording, setIsRecording] = useState(false);

    // Handle controlled vs uncontrolled input
    const isControlled = value !== undefined
    const currentValue = isControlled ? (value as string) : internalValue

    const {
      handleInput,
      lastInterimRef
    } = useSpeechRecognition({
      inputRef: textareaRef,
      setInternalValue,
      isRecording,
      setIsRecording,
      isControlled,
      currentValue,
      value,
      onChange
    });

    return (
      <div className="relative">
        {isRecording && (
          <div className="absolute -top-9 right-0 inline-flex items-center gap-2 rounded-full text-white px-3 py-1 text-xs font-medium bg-red-500 ring-1 ring-inset ring-red-500/20">
            <div className="h-1.5 w-1.5 rounded-full bg-white" />Recording
          </div>
        )}
        <textarea
          {...props}
          value={(currentValue || '') + (lastInterimRef.current ? ' ' + lastInterimRef.current + '🎤' : '')}
          onChange={handleInput}
          ref={(element) => {
            if (typeof ref === 'function') {
              ref(element)
            } else if (ref) {
              ref.current = element
            }
            textareaRef.current = element
          }}
          className={cn(
            "flex min-h-[80px] w-full rounded-md border border-[#2e3835] bg-[#111] px-3 py-2 text-xs ring-offset-background placeholder:text-muted-foreground focus-visible:outline-1 outline-offset-4 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
        />
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
